import IconButton from '@mui/material/IconButton';
import { PopoverKind } from '../PopoverContent';
import SwapVertIcon from '@mui/icons-material/SwapVert';
import Tooltip from '@mui/material/Tooltip';

export default ({
  openPopover
}: {
  openPopover: (
    anchorEl: HTMLButtonElement | null,
    popoverKind: PopoverKind
  ) => void;
}) => {
  const btnTitle = 'Move to other page';

  const handleMoveCompClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    openPopover(event.currentTarget, PopoverKind.MOVE_PAGE);
  };

  return (
    <Tooltip title={btnTitle} followCursor>
      <IconButton
        aria-label={btnTitle}
        onClick={handleMoveCompClick}
        size="small"
      >
        <SwapVertIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
};
